<template>
  <TranslationDisplay
    class="story-title mb-4"
    tag="h4"
    :translation="lift.title"
    html
  />
</template>

<script>
import Vue from 'vue'
import TranslationDisplay from '../../base/Translation/TranslationDisplay.vue'

export default Vue.extend({
  name: 'LiftTitle',
  components: { TranslationDisplay },
  props: {
    lift: {
      type: Object,
      required: true
    },
  }
})
</script>

<style
  scoped
  lang="scss"
>
.story-title {
  font-size: 28px;
  line-height: 2.714rem;
}

</style>